export default __webpack_public_path__ + "static/media/fi_distress.7830af17.png";